import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { Setting } from '@shared/setting/setting';
import { SettingApi } from '@shared/setting/setting-api.service';
import { SettingGroup } from '@shared/setting/setting-group.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingListResolver {
  constructor(
    private sessionService: SessionService,
    private settingApi: SettingApi,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Setting[]> | Promise<Setting[]> | Setting[] {
    const group: SettingGroup = route.data.settingGroup;
    switch (group) {
      case SettingGroup.MONEYBAR: {
        if (!route.data.rolesToEdit || this.sessionService.hasRole(route.data.rolesToEdit)) {
          return this.settingApi.getMoneybarSettings();
        } else {
          return [];
        }
      }
      default:
        return [];
    }
  }
}
